/**
 * Waits for a predicate to be true and then calls onSuccess. If the predicate is false then it is retried the number of times
 * specified with the delay. Each attempt waits the specified number of times before testing the predicate again. onFailure is
 * called if the predicate doesn't succeed within the given number of attempts. onFailure is optional
 * @param {Function} predicate
 * @param {number} maxAttemptCount
 * @param {number} attemptWaitMs
 * @param {Function} onSuccess
 * @param {Function|undefined} onFailure
 */

export default function waitFor (predicate, maxAttemptCount, attemptWaitMs, onSuccess, onFailure) {
    let attemptsRemaining = maxAttemptCount;
    const closure = () => {
        const result = predicate();
      if (result) {
            onSuccess();
        } else {
            attemptsRemaining--;
            if (attemptsRemaining <= 0) {
                if (onFailure) {
                    onFailure();
                }
            } else {
                setTimeout(closure, attemptWaitMs == undefined ? 100 : attemptWaitMs)
            }
        }
    }
    closure();
}



// WEBPACK FOOTER //
// ./js/utils/WaitFor.js